<template>
	<div class="stat-card" :class="variant">
		<div class="icon-area">
			<img :src="icon" :alt="label" class="stat-icon" />
		</div>
		<div class="content">
			<p class="label">{{ label }}</p>
			<p class="value">{{ value }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SavedToSpendStatCard',
	props: {
		icon: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		value: {
			type: String,
			required: true
		},
		variant: {
			type: String,
			default: 'gold',
			validator: (val) => ['gold', 'blue', 'purple'].includes(val)
		}
	}
}
</script>

<style scoped>
.stat-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 1;
	background: #FFFFFF;
	border-radius: 8px;
}

.icon-area {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 12px 0;
	border-radius: 8px 8px 0 0;
}

.stat-card.gold .icon-area {
	background: #FCE5D4;
}

.stat-card.blue .icon-area {
	background: #D0D4EF;
}

.stat-card.purple .icon-area {
	background: #5A506E;
}

.stat-icon {
	width: 24px;
	height: 24px;
}

.content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 4px;
	padding: 8px 0;
	width: 100%;
	flex: 1;
}

.label {
	font-size: 11px;
	line-height: 1.1;
	text-align: center;
	color: #413655;
	margin: 0;
	white-space: pre-line;
}

.value {
	font-size: 15px;
	line-height: 1.4;
	font-weight: bold;
	text-align: center;
	color: #413655;
	margin: 0;
}
</style>
